// 3rd Party
import PropTypes from 'prop-types';
import React from 'react';

// Component
const EducationSvg = ({ color, height, width }) => (
  <svg
    height={height}
    viewBox="0 0 36 40"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    role="presentation"
  >
    <g fill={color} fillRule="evenodd">
      <path d="M34.567 39.512H12.835c-2.54 0-4.61-2.07-4.61-4.61V4.61a3.296 3.296 0 00-3.292-3.293.657.657 0 01-.658-.658c0-.366.294-.66.658-.66h25.683c2.54 0 4.61 2.068 4.61 4.61v34.243a.66.66 0 01-.66.66zM8.157 1.317A4.6 4.6 0 019.543 4.61v30.292a3.296 3.296 0 003.292 3.293h21.073V4.61a3.296 3.296 0 00-3.292-3.293H8.156z" />
      <path d="M8.914 9.22H1.01a.658.658 0 01-.657-.66V4.61A4.615 4.615 0 014.963 0h8.56a.659.659 0 110 1.317h-8.56A3.296 3.296 0 001.67 4.61v3.292h7.244a.658.658 0 010 1.317z" />
      <path d="M31.622 37.38H15.16a4.615 4.615 0 01-4.61-4.61V3.797c0-.364.293-.66.658-.66H27.67c2.542 0 4.61 2.07 4.61 4.61v28.976c0 .364-.294.66-.658.66zM11.866 4.455V32.77a3.297 3.297 0 003.293 3.294h15.803V7.747a3.296 3.296 0 00-3.292-3.293H11.867z" />
      <path d="M21.433 29.612c-2.54 0-4.61-2.07-4.61-4.61 0-2.54 2.07-4.61 4.61-4.61 2.54 0 4.61 2.07 4.61 4.61 0 2.54-2.07 4.61-4.61 4.61zm0-7.903a3.295 3.295 0 00-3.292 3.292 3.297 3.297 0 003.293 3.292 3.296 3.296 0 003.293-3.292 3.296 3.296 0 00-3.293-3.293z" />
      <path d="M24.32 32.186a.658.658 0 01-.66-.658c0-1.2-.775-1.976-1.975-1.976-1.2 0-1.976.776-1.976 1.976a.658.658 0 01-1.318 0c0-1.907 1.386-3.293 3.293-3.293 1.907 0 3.292 1.386 3.292 3.293a.657.657 0 01-.658.658zm-3.042-6.04a1.33 1.33 0 01-.93-.382 1.33 1.33 0 01-.387-.935c0-.344.14-.686.383-.93.494-.493 1.376-.493 1.863-.006a1.309 1.309 0 010 1.863c-.243.25-.58.388-.928.388zm1.85-19.339h-3.293a.659.659 0 110-1.318h3.293a.658.658 0 010 1.317zm6.362 3.923H14.346a.659.659 0 110-1.318H29.49a.658.658 0 110 1.318zm0 2.352H14.346a.659.659 0 110-1.317H29.49a.658.658 0 110 1.318zm-2.914 3.138h-9.878a.66.66 0 010-1.318h9.878a.658.658 0 010 1.318zm2.7 3.136h-3.95a.658.658 0 110-1.318h3.95a.66.66 0 010 1.318z" />
    </g>
  </svg>
);
EducationSvg.propTypes = {
  color: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
};

export default EducationSvg;
